import { useDispatch } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";

import { showErrorToast } from "app/actions/toast_actions";
import { renderErrorToast } from "app/pages/sales-intelligence/common-components/ErrorToast/ErrorToast";
import { useSuccessToast } from "app/pages/sales-intelligence/hooks/useSuccessToast";

export const usePlaybookToasts = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();
    const { showSuccess } = useSuccessToast();

    /** For server-provided text that has no translation key, e.g. a validation reason returned on a 400. */
    const showErrorMessage = (message: string) => {
        dispatch(
            showErrorToast(
                renderErrorToast({
                    content: message,
                    minWidth: "auto",
                }),
            ),
        );
    };

    const showError = () => {
        showErrorMessage(translate("si.common.toast.error"));
    };

    return { showSuccess, showError, showErrorMessage };
};
